import { IDocumentLibraryService } from "../../documents"
import { IFieldsMapFactory } from "../../fields/map"
import { AngularReactDialog, AngularReactDialogContext } from "../../react/reactAngularDialog"
import { IOmniaSession } from "../../types"
import { DocumentLibraryPopup } from "./Popup"

export const ReactDocumentLibrary: AngularReactDialog = {

    inject: {
        session: "OmniaSession",
        svc: "OmniaDocumentLibraryService",
        mapFactory: "OmniaFieldsMapFactory"
    },

    component: DocumentLibraryPopupWrapper

}

function DocumentLibraryPopupWrapper({ dependencies, arguments: args, close }: AngularReactDialogContext) {

    const session: IOmniaSession = dependencies["session"]
    const svc: IDocumentLibraryService = dependencies["svc"]
    const mapFactory: IFieldsMapFactory = dependencies["mapFactory"]

    return (
        <DocumentLibraryPopup
            svc={svc}
            mapFactory={mapFactory}
            session={session}
            args={args}
            close={close}
        />
    )
}
